export default __webpack_public_path__ + "static/media/sensors.7c068631.png";